import { render } from "./IconExclamation.vue?vue&type=template&id=35b18fd8"
import script from "./IconExclamation.vue?vue&type=script&lang=js"
export * from "./IconExclamation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__